<script setup lang="ts"></script>

<template>
  <NuxtLayout>
    <NuxtPage :keepalive="{ include: ['users', 'organizations'] }" />
  </NuxtLayout>
</template>

<style></style>
